/**
 * Reduce Motion Toggle
 * Allows users to manually disable animations throughout the site
 * Syncs with system preferences and saves preference to localStorage
 */

(function() {
  'use strict';

  // Check if user has a saved preference or system preference
  function getMotionPreference() {
    // First check localStorage for manual preference
    const saved = localStorage.getItem('reduceMotion');
    if (saved !== null) {
      return saved === 'true';
    }
    
    // Fall back to system preference
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Apply or remove the reduce-motion class
  function setReduceMotion(enabled) {
    if (enabled) {
      document.documentElement.classList.add('reduce-motion');
      document.body.classList.add('reduce-motion');
    } else {
      document.documentElement.classList.remove('reduce-motion');
      document.body.classList.remove('reduce-motion');
    }
    
    // Save preference
    localStorage.setItem('reduceMotion', enabled);
    
    // Stop or restart videos based on preference
    const videos = document.querySelectorAll('video[autoplay]');
    videos.forEach(video => {
      if (enabled) {
        video.pause();
      } else {
        video.play().catch(err => console.log('Video play prevented:', err));
      }
    });
    
    // Dispatch custom event for other scripts to listen to
    window.dispatchEvent(new CustomEvent('reducedMotionChange', { 
      detail: { enabled: enabled } 
    }));
  }

  // Initialize on page load
  function init() {
    const shouldReduce = getMotionPreference();
    setReduceMotion(shouldReduce);
    
    // Update toggle button state if it exists
    updateToggleButton(shouldReduce);
  }

  // Update toggle button appearance
  function updateToggleButton(isEnabled) {
    const toggles = document.querySelectorAll('[data-reduce-motion-toggle]');
    toggles.forEach(toggle => {
      toggle.setAttribute('aria-pressed', isEnabled);
      if (toggle.querySelector('.toggle-text')) {
        toggle.querySelector('.toggle-text').textContent = 
          isEnabled ? 'Enable Animations' : 'Reduce Motion';
      }
    });
  }

  // Toggle function
  window.toggleReduceMotion = function() {
    const currentState = document.documentElement.classList.contains('reduce-motion');
    const newState = !currentState;
    setReduceMotion(newState);
    updateToggleButton(newState);
  };

  // Listen for system preference changes
  const motionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  motionMediaQuery.addEventListener('change', (e) => {
    // Only auto-update if user hasn't manually set a preference
    if (localStorage.getItem('reduceMotion') === null) {
      setReduceMotion(e.matches);
      updateToggleButton(e.matches);
    }
  });

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Set up toggle buttons
  document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('[data-reduce-motion-toggle]');
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        window.toggleReduceMotion();
      });
    });
  });

})();